import React from "react";
import { colors, radius } from "./tokens";

type Tone = "success" | "danger" | "warning" | "accent" | "neutral";

const TONES: Record<Tone, { bg: string; fg: string }> = {
  success: { bg: colors.successSoft, fg: colors.success },
  danger: { bg: colors.dangerSoft, fg: colors.danger },
  warning: { bg: colors.warningSoft, fg: colors.warning },
  accent: { bg: colors.accentSoft, fg: colors.accent },
  neutral: { bg: "#F0F1F3", fg: colors.textMuted },
};

// Pastille de statut — remplace les span inline dupliqués (couleurs répétées à chaque écran) et
// les glyphes texte façon "✓ Vérifié" par un composant unique, avec un point plein optionnel
// (matérialise un état "en attente"/"actif" sans dépendre d'une icône).
export function Badge({ children, tone = "neutral", dot }: { children: React.ReactNode; tone?: Tone; dot?: boolean }) {
  const t = TONES[tone];
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      backgroundColor: t.bg, color: t.fg, fontSize: 11.5, fontWeight: 700,
      padding: "4px 10px", borderRadius: radius.pill, whiteSpace: "nowrap",
    }}>
      {dot && <span style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: t.fg, flexShrink: 0 }} />}
      {children}
    </span>
  );
}
